import type { PayPalNamespace } from '@paypal/paypal-js';
import { loadScript } from '@paypal/paypal-js';

let payPal: PayPalNamespace = null;
let payPalSdkPromise: Promise<PayPalNamespace> = null;

function convertCountryCode(countryCode: string) {
	return countryCode.replace('-', '_');
}

export async function ensurePayPalSdk(
	clientId: string,
	bnCode: string,
	merchantId: string,
	clientToken: string,
	currency: string = null,
	locale: string = null
): Promise<PayPalNamespace | void> {
	if (payPal)
		return payPal;
	if (!payPalSdkPromise) {
		payPalSdkPromise = loadScript({
			clientId: clientId,
			merchantId: merchantId,
			commit: false,
			debug: false,
			currency: currency.toLocaleUpperCase(),
			locale: convertCountryCode(locale),
			intent: 'capture',
			components: 'buttons,hosted-fields,funding-eligibility',
			dataClientToken: clientToken,
			dataPartnerAttributionId: bnCode,
			enableFunding: 'venmo'
		}).then(payPalSdk => {
			payPal = payPalSdk;
			payPalSdkPromise = null;
			return payPal;
		}).catch(error => {
			// Null out the promise field so that it could be re-attempted
			payPalSdkPromise = null;
			// Re-raise the original error
			throw error;
		});
	}
	return payPalSdkPromise;
}